import React from 'react';

const IconlyCurvedLightCalendar = ({ width = 24, height = 24, stroke = "#B1B1B1", style = {margin: 0} }) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.75 12.776c0-6.956 2.319-9.274 9.274-9.274 6.956 0 9.275 2.318 9.275 9.274 0 6.956-2.319 9.274-9.275 9.274-6.955 0-9.274-2.318-9.274-9.274Z"
      clipRule="evenodd"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M3.025 9.324h18.008m-4.603 3.937h.008m-4.409 0h.009m-4.416 0h.01m8.798 3.852h.008m-4.409 0h.009m-4.416 0h.01M16.033 2.05v3.262M8.025 2.05v3.262"
    />
  </svg>
);

export default IconlyCurvedLightCalendar;